module.exports = __webpack_public_path__ + "img/kam.4a575e1d.jpg";